export interface CityCoordinate {
  name: string;
  lat: number;
  lng: number;
  region: "west_valley";
  slug?: string;
}

export const CITY_COORDINATES: CityCoordinate[] = [
  { name: "Tolleson", lat: 33.4498, lng: -112.2590, region: "west_valley", slug: "tolleson-az" },
  { name: "Avondale", lat: 33.4356, lng: -112.3496, region: "west_valley", slug: "avondale-az" },
  { name: "Goodyear", lat: 33.4353, lng: -112.3577, region: "west_valley", slug: "goodyear-az" },
  { name: "Glendale", lat: 33.5387, lng: -112.1860, region: "west_valley", slug: "glendale-az" },
  { name: "Peoria", lat: 33.5806, lng: -112.2374, region: "west_valley", slug: "peoria-az" },
  { name: "Surprise", lat: 33.6292, lng: -112.3322, region: "west_valley", slug: "surprise-az" },
  { name: "Phoenix", lat: 33.4484, lng: -112.0740, region: "west_valley", slug: "phoenix-az" },
  { name: "Buckeye", lat: 33.3703, lng: -112.5838, region: "west_valley", slug: "buckeye-az" },
  { name: "Litchfield Park", lat: 33.4934, lng: -112.3577, region: "west_valley" },
  { name: "Sun City", lat: 33.5978, lng: -112.2718, region: "west_valley", slug: "sun-city-az" },
  { name: "Sun City West", lat: 33.6581, lng: -112.3445, region: "west_valley", slug: "sun-city-west-az" },
  { name: "El Mirage", lat: 33.6131, lng: -112.3246, region: "west_valley", slug: "el-mirage-az" },
  { name: "Youngtown", lat: 33.5942, lng: -112.3013, region: "west_valley" },
  { name: "Waddell", lat: 33.5667, lng: -112.4531, region: "west_valley" },
];

export const HQ_COORDINATES = { lat: 33.4498, lng: -112.2590 };
